package ui.theme

object AppTypography {
    // Font Families
    val primaryFont = "SF Pro Display, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, sans-serif"
    val codeFont = "Fira Code, SF Mono, Monaco, Inconsolata, Roboto Mono, Consolas, monospace"
    
    // Font Weights
    val thin = 100
    val light = 300
    val regular = 400
    val medium = 500
    val semiBold = 600
    val bold = 700
    val extraBold = 800
    val black = 900
    
    // Font Sizes (as strings for CSS)
    val xs = "0.75rem"     // 12px
    val sm = "0.875rem"    // 14px
    val base = "1rem"      // 16px
    val lg = "1.125rem"    // 18px
    val xl = "1.25rem"     // 20px
    val xl2 = "1.5rem"     // 24px
    val xl3 = "1.875rem"   // 30px
    val xl4 = "2.25rem"    // 36px
    val xl5 = "3rem"       // 48px
    val xl6 = "3.75rem"    // 60px
    val xl7 = "4.5rem"     // 72px
    
    // Line Heights
    val leadingNone = 1.0
    val leadingTight = 1.25
    val leadingSnug = 1.375
    val leadingNormal = 1.5
    val leadingRelaxed = 1.625
    val leadingLoose = 2.0
    
    // Letter Spacing (as strings for CSS)
    val trackingTighter = "-0.05em"
    val trackingTight = "-0.025em"
    val trackingNormal = "0em"
    val trackingWide = "0.025em"
    val trackingWider = "0.05em"
    val trackingWidest = "0.1em"
    
    // Text Shadow
    val textShadowSm = "0 1px 2px rgba(0, 0, 0, 0.05)"
    val textShadowMd = "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)"
    val textShadowLg = "0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.06)"
    val textShadowXl = "0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)"
    
    // Gradient Text (for CSS)
    val primaryGradientText = """
        background: linear-gradient(135deg, #1e40af, #3b82f6, #60a5fa);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    """.trimIndent()
    
    val accentGradientText = """
        background: linear-gradient(135deg, #7c3aed, #a855f7, #c084fc);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    """.trimIndent()
}
